var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "view-snapshot-button",
      class: _vm.position,
      attrs: { role: "button", tabindex: "-1", "aria-disabled": _vm.disabled },
      on: { click: _vm.onClick },
    },
    [
      _c("VIcon", { attrs: { icon: "mdi-image-multiple", size: "20" } }),
      _vm._v(" "),
      _c("span", { staticClass: "tip" }, [_vm._v("查看预览图")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }